"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CaptionSt = require("./Caption.st.css");
var _Ellipsis = _interopRequireWildcard(require("../common/Ellipsis"));
var _EllipsisCommon = require("../common/PropTypes/EllipsisCommon");
var _excluded = ["caption", "tagName", "ellipsis", "appendTo", "flip", "fixed", "placement", "zIndex", "enterDelay", "exitDelay", "showTooltip"],
  _excluded2 = ["dataHook", "className", "tagName", "caption", "light", "children"];
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Text/Caption.js";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CaptionWithEllipsis = _ref => {
  var {
      caption = 'c1',
      tagName = 'span',
      ellipsis = false,
      appendTo = _Ellipsis.default.defaultProps.appendTo,
      flip = _Ellipsis.default.defaultProps.flip,
      fixed = _Ellipsis.default.defaultProps.fixed,
      placement = _Ellipsis.default.defaultProps.placement,
      zIndex = _Ellipsis.default.defaultProps.zIndex,
      enterDelay = _Ellipsis.default.defaultProps.enterDelay,
      exitDelay = _Ellipsis.default.defaultProps.exitDelay,
      showTooltip = _Ellipsis.default.defaultProps.showTooltip
    } = _ref,
    propsWithNoDefaults = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var _Ellipsis$defaultProp = _objectSpread(_objectSpread({}, _Ellipsis.default.defaultProps), {}, {
      caption,
      tagName,
      ellipsis,
      appendTo,
      flip,
      fixed,
      placement,
      zIndex,
      enterDelay,
      exitDelay,
      showTooltip
    }, propsWithNoDefaults),
    {
      dataHook,
      className,
      tagName: _tagName,
      caption: _caption,
      light,
      children
    } = _Ellipsis$defaultProp,
    props = (0, _objectWithoutProperties2.default)(_Ellipsis$defaultProp, _excluded2);
  var {
    ellipsisProps,
    componentProps
  } = (0, _Ellipsis.extractEllipsisProps)(props);
  return /*#__PURE__*/_react.default.createElement(_Ellipsis.default, (0, _extends2.default)({}, ellipsisProps, {
    wrapperClassName: _CaptionSt.classes[caption],
    render: _ref2 => {
      var {
        ref,
        ellipsisClasses
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(tagName, _objectSpread({
        ref,
        className: (0, _CaptionSt.st)(_CaptionSt.classes.root, {
          caption
        }, ellipsisClasses(className)),
        'data-hook': dataHook,
        'data-light': light
      }, componentProps), children);
    },
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }));
};
CaptionWithEllipsis.displayName = 'Caption';
CaptionWithEllipsis.propTypes = _objectSpread({
  /** Applied as data-hook HTML attribute that can be used in the tests */
  dataHook: _propTypes.default.string,
  /** class to be applied to the root element */
  className: _propTypes.default.string,
  /** tag name that will be rendered */
  tagName: _propTypes.default.string,
  caption: _propTypes.default.oneOf(['c1', 'c2']),
  /** make the text color lighter */
  light: _propTypes.default.bool
}, _EllipsisCommon.EllipsisCommonProps);
var _default = exports.default = CaptionWithEllipsis;
//# sourceMappingURL=Caption.js.map